import React from 'react'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import Footer from 'react-multi-date-picker/plugins/range_picker_footer'
import InputIcon from 'react-multi-date-picker/components/input_icon'
import { Controller, useFormContext } from 'react-hook-form'

export const MultiDateTimePickers = (props) => {
  const { source, setDate , minDate = new DateObject() } = props
  const { control } = useFormContext()

  return (
    <>
      <Controller
        control={control}
        name={source}
        rules={{ required: true }} //optional
        render={({
          field: { onChange, name, value },
          formState: { errors }, //optional, but necessary if you want to show an error message
        }) => (
          <>
            <DatePicker
              minDate={minDate}
              value={value || ''}
              onChange={(dateValue) => {
                if (dateValue.length === 2) {
                  if (dateValue[0].isValid && dateValue[1].isValid) {
                    onChange(dateValue)
                    setDate(dateValue)
                  }
                }
              }}
              range
              numberOfMonths={2}
              render={<InputIcon />}
              plugins={[
                <Footer
                  position='bottom'
                  names={{
                    selectedDates: 'informacion del vuelo:',
                    from: 'salida:',
                    to: 'llegada:',
                    selectDate: 'selecciona',
                    close: 'cerrar',
                    separator: ',',
                  }}
                />,
              ]}
            />
            {errors && errors[name] && errors[name].type === 'required' && (
              //if you want to show an error message
              <span>your error message !</span>
            )}
          </>
        )}
      />
    </>
  )
}
